<template>
  <div>
    <div class="nav-mobile navbar-dark">
      <div class="link-container">
        <div
          class="hover-link px-2"
          v-for="(building, key) in buildingList"
          :key="key"
        >
          <router-link :to="`/village/${building}`">
            <img
              draggable="false"
              :alt="building"
              class="img-fluid"
              :src="`/img/vectors/x32/${building}.png`"
            />
          </router-link>
        </div>

        <div class="hover-link px-2 position-relative">
          <router-link to="/village/movements">
            <img
              draggable="false"
              title="Movements"
              alt=""
              class="img-fluid"
              src="/img/sprite/resources/x32/scroll.png"
            />
            <span v-if="incomingCount > 0" class="movement-badge">{{ incomingCount }}</span>
          </router-link>
        </div>

        <div class="hover-link px-2">
          <router-link
            :to="`/village/map?x=${activeVillage?.position?.x}&y=${activeVillage?.position?.y}`"
          >
            <img
              draggable="false"
              title="World Map"
              alt=""
              class="img-fluid"
              src="/img/sprite/resources/x32/map.png"
            />
          </router-link>
        </div>

        <div class="hover-link px-2">
          <router-link :to="tribeNav">
            <img
              draggable="false"
              title="Tribes"
              alt=""
              class="img-fluid"
              src="/img/vectors/x32/clan.png"
            />
          </router-link>
        </div>

        <div class="hover-link px-2">
          <router-link to="/shop">
            <img
              draggable="false"
              title="Shop"
              alt=""
              class="img-fluid"
              src="/img/vectors/x32/gem.png"
            />
          </router-link>
        </div>
        <div @click="navOpen = !navOpen" class="hover-link px-2">
          <button
            class="navbar-toggler px-1"
            type="button"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="navOpen" class="nav-mobile-dropdown" style="">
      <!-- chrono logo -->
      <router-link
        class="navbar-brand me-0"
        :to="$store.state.wallet.connected ? '/village' : '/'"
      >
        <img
          draggable="false"
          src="/favicon.png"
          height="40"
          class="d-inline-block align-top"
          alt=""
        />
        <h4 class="d-inline-block mb-0 mt-1 ms-2">Chrono Kingdoms</h4>
      </router-link>

      <!-- resources -->
      <div
        v-if="$store.state.wallet.connected"
        style="
          display: flex;
          gap: 20px;
          justify-content: center;
          align-items: center;
        "
        class="my-2"
      >
        <router-link
          to="/village/farm"
          class="text-center"
          style="
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            draggable="false"
            title="Food"
            alt="Food"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/wheat.png"
          />
          <h6 class="res-num-mobile" :title="fmtFull.format(resources.food)">
            {{ fmtK.format(resources.food) }}
          </h6>
        </router-link>
        <router-link
          to="/village/mine"
          class="text-center"
          style="
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            draggable="false"
            title="Gold"
            alt="Gold"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/gold.png"
          />
          <h6 class="res-num-mobile" :title="fmtFull.format(resources.gold)">
            {{ fmtK.format(resources.gold) }}
          </h6>
        </router-link>
        <router-link
          to="/village/mana"
          class="text-center"
          style="
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            draggable="false"
            title="Mana"
            alt="Mana"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/mana.png"
          />
          <h6 class="res-num-mobile" :title="fmtFull.format(resources.mana)">
            {{ fmtK.format(resources.mana) }}
          </h6>
        </router-link>
        <router-link
          to="/village/farm"
          class="text-center"
          style="
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            draggable="false"
            title="Population"
            alt="Population"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/population.png"
          />
          <h6 class="res-num-mobile" :title="fmtFull.format(availablePopulation)">
            {{ fmtK.format(availablePopulation) }}
          </h6>
        </router-link>
      </div>

      <div class="nav-item w-full my-2" v-if="$store.state.wallet.connected">
        <router-link class="btn btn-primary w-full" to="/village">
          <img draggable="false" alt="" src="/img/vectors/x32/home.png" />
          My Village
        </router-link>
      </div>
      <div class="nav-item w-full" v-else>
        <router-link class="btn btn-primary w-full" to="/login">
          <img
            draggable="false"
            alt=""
            src="/img/vectors/x32/arrow_right.png"
          />
          Play Now
        </router-link>
      </div>

      <ul
        class="navbar-nav me-auto mb-lg-0 "
        v-if="$store.state.user.villages?.length > 1"
      >
        <li class="nav-item">
          <router-link
            to="/worlds/village/select"
            class="nav-link text-uppercase"
          >
            <img
              draggable="false"
              title="Village Select"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/ring.png"
            />
            <span class="d-md-none d-xl-inline">Villages</span>
          </router-link>
        </li>
      </ul>
      <hr style="background: white; margin: 0px; min-height: 1px !important" class="my-2" />

      <!-- tabs -->
      <ul class="navbar-nav me-auto mb-lg-0">
        <li class="nav-item">
          <router-link class="nav-link text-uppercase" to="/worlds">
            <img
              draggable="false"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/compass.png"
            />
            <span class="d-md-none d-xl-inline">Worlds</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link text-uppercase" to="/village">
            <img
              draggable="false"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/attack.png"
            />
            <span class="d-md-none d-xl-inline">Game</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link text-uppercase" to="/guide">
            <img
              draggable="false"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/book.png"
            />
            <span class="d-md-none d-xl-inline">Guide</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link text-uppercase" to="/explorer">
            <img
              draggable="false"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/compass.png"
            />
            <span class="d-md-none d-xl-inline">Explorer</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link text-uppercase" to="/faucet">
            <img
              draggable="false"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/hard_hat.png"
            />
            <span class="d-md-none d-xl-inline">Faucet</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link text-uppercase" to="/shop">
            <img
              draggable="false"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/gem.png"
            />
            <span class="d-md-none d-xl-inline">Shop</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link text-uppercase" to="/settings">
            <img
              draggable="false"
              alt=""
              height="28px"
              class="mx-2"
              src="/img/vectors/x32/gear.png"
            />
            <span class="d-md-none d-xl-inline">Settings</span>
          </router-link>
        </li>
      </ul>

      <!-- links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            class="mx-1 me-md-3"
            target="_blank"
            href="https://discord.gg/hn3Ds2bnqz"
          >
            <img
              draggable="false"
              alt=""
              class="mt-2"
              height="28px"
              src="/img/vectors/socials/x64/discord.png"
            />
          </a>
          <a
            class="mx-1 me-md-3"
            target="_blank"
            href="https://x.com/ChronoKingdoms"
          >
            <img
              draggable="false"
              alt=""
              class="mt-2"
              height="28px"
              src="/img/vectors/socials/x64/x-white.png"
            />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import router from "@/router";
import store from "@/store";
import { computed, ref, watch, onMounted, onBeforeUnmount } from "vue";
import { fmtK } from "@/types/utils";
import { calculateCurrentPopulation, calculateFarmCapacity } from "@/utils/population";

const fmtFull = new Intl.NumberFormat('en');

// computed
const activeVillage = computed(() => {
  return store.state.village.village;
});
const tribeNav = computed(() => {
  if (store.state.user.client?.userData?.tribe) {
    return `/tribes/${store.state.user.client.userData.tribe}`;
  }
  return "/tribes";
});
const resources = computed(() => {
  const resource = activeVillage.value?.resources;
  const toNum = (v) => {
    if (typeof v === 'number') return v;
    if (typeof v?.toNumber === 'function') return v.toNumber();
    return Number(v) || 0;
  };
  return {
    food: Math.max(0, toNum(resource?.food)),
    mana: Math.max(0, toNum(resource?.mana)),
    gold: Math.max(0, toNum(resource?.gold)),
  };
});

const currentPopulation = computed(() => {
  return calculateCurrentPopulation(activeVillage.value);
});

const farmCapacity = computed(() => {
  return calculateFarmCapacity(activeVillage.value);
});

const availablePopulation = computed(() => {
  return Math.max(0, farmCapacity.value - currentPopulation.value);
});

// data
const buildingList = ["hq", "barracks", "market"];
const navOpen = ref(false);
const incomingCount = ref(0);
let incomingPoll: ReturnType<typeof setInterval> | null = null;

// methods
function closeNav() {
  navOpen.value = false;
}

function fetchIncomingCount() {
  const client = store.state.user.client;
  const village = store.state.user.active_village;
  if (!client || !village) return;

  client.getActiveAttacks(village).then((attacks: any[]) => {
    const activeKey = village.toString();
    incomingCount.value = attacks.filter(
      (a: any) => !a.account.arrived && a.account.dstVillage?.toString() === activeKey
    ).length;
  }).catch(() => {});
}

// lifecycle
watch(() => store.state.user.active_village, () => fetchIncomingCount());

onMounted(() => {
  setTimeout(() => {
    fetchIncomingCount();
  }, 2000);
  incomingPoll = setInterval(fetchIncomingCount, 60_000);
});

onBeforeUnmount(() => {
  if (incomingPoll) clearInterval(incomingPoll);
});

router.afterEach(() => {
  closeNav();
});
</script>

<style scoped>
.nav-mobile {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  height: 60px;
  background-color: var(--bg-secondary);
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-mobile-dropdown {
  position: absolute;
  bottom: 60px;
  right: 0;
  left: 0;
  top: 0;
  background-color: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  z-index: 8;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  padding-inline: 1rem;
  position: fixed;
  overflow: auto;
}
.link-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navbar-brand,
.navbar-dark .navbar-nav .nav-link:hover,
.nav-item:hover {
  color: white;
  text-underline-offset: 0.4rem;
  text-decoration: underline;
  text-decoration-thickness: 2px;
}
.w-full {
  width: 100%;
}

.movement-badge {
  position: absolute;
  top: -4px;
  right: -2px;
  background: #dc3545;
  color: white;
  border-radius: 50%;
  font-size: 0.65rem;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  line-height: 1;
}

.res-num-mobile {
  margin-bottom: 0;
  font-size: 1rem;
  font-variant-numeric: tabular-nums;
  min-width: 40px;
  text-align: center;
}
</style>
